
import Breadcrumbs from "~/components/UI/Breadcrumbs";
import OtherNews from "~/components/articles/OtherNews.vue";
import {formaterOgTitle} from "~/helpers/formaterOgTitle";

export default {
  fetch: async function () {
    await this.getArticle();
  },

  head: function () {
    const title = this.article?.seo_title || `${this.article?.title} ${this.userCity}`;
    const description = this.article?.seo_description;

    return {
      title: title,
      meta: [
        {name: 'og:title', hid: 'og:title', property: 'og:title', content: formaterOgTitle(title, this.$store.state.appState.config)},

        {hid: 'metadescription', name: 'description', content: description},
        {hid: 'og:description', name: 'og:description', property: 'og:description', content: description}
      ],
    }
  },
  data: function () {
    return {
      article: {}
    }
  },

  computed: {
    breadcrumbs: function () {
      return [
        { title: "Главная", path: "/" },
        { title: "Статьи", path: "/articles" },
        { title: this.article?.title, path: this.$route.fullPath },
      ]
    },
    userCity: function () {
      const city = this.$store.state?.appState?.config?.city?.data?.parental || this.$store.state?.appState?.config?.city?.data?.city_name;

      return `из ${city}`
    },
    cmsPageId: function () {
      return Number.parseFloat(this.article?.cms_page_id || 0)
    },

    articleDate: function () {
      return new Date(this.article?.publish_from * 1000).toLocaleDateString('ru', {
        day: '2-digit',
        month: "long",
        year: 'numeric'
      });
    },
  },

  components: {
    Breadcrumbs,
    OtherNews
  },

  methods: {
    getArticle: async function () {
      const slug = this.$route?.params?.slug;
      const article = await this.$api.agent.transport.get(`/articles/${ slug }?expand=image,category,tags`).then((res) => {
        return res.data
      }).catch((err) => {
        return null
      });
      if (!article) {
        this.$nuxt.error({
          statusCode: 404,
          message: "Новость не найдена"
        });
        return
      }
      this.article = article || {};
      this.isUrlWithId();
    },
    // редирект через 301, т.к по id страница тоже доступна, для сео
    isUrlWithId: function () {
      const path = this.$route.fullPath;
      const _slugFromUrl = path.split('/').reverse()?.[0];

      if (this.article) {
        if (_slugFromUrl === String(this.article.id)) {
          return this.$nuxt.context.redirect(301, String(this.article.slug));
        }
      }
    },
  },
};
